import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../components/loader/Loader'
import appConfig from '../../../config'
import routes from '../../../routes'
import { LiveSessionType } from '../../../slices/sessionSlice'
import OnDemandFile from './OnDemandFile'
import Note from './OnDemandNote'
import { OnDemandShowStyle } from './styled'

export interface RecordedSessionType extends LiveSessionType {
  playbackUrl?: string
  m1Title?: string
  m2Title?: string
  m3Title?: string
  m1Desc?: string
  m2Desc?: string
  m3Desc?: string
  m1Upload?: string
  m2Upload?: string
  m3Upload?: string
}

const OnDemandShow = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [recordedSession, setRecordedSession] = useState<RecordedSessionType>()
  const { id } = useParams()

  useEffect(() => {
    const body = document.querySelector('#root')
    body?.scrollIntoView()
  }, [])

  useEffect(() => {
    axios
      .get(`${appConfig.API_URL}/on-demand/${id}`)
      .then(({ status, data }) => {
        setRecordedSession(data.recording)
        setLoading(false)
      })
      .catch((err) => {
        console.log(err)
        toast(err.response?.data?.message)
        navigate(routes.onDemandSessions, { replace: true })
      })
  }, [])

  if (loading || !recordedSession) return <Loader />

  return (
    <OnDemandShowStyle>
      <div className="filterOverlay">
        <div className="container gridContainer">
          <div className="leftGrid">
            <div className="vimeoContainer mb-2">
              <iframe
                title="LESA+2023+v8+Final+16_9"
                src={recordedSession?.playbackUrl}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
              <script src="https://player.vimeo.com/api/player.js"></script>
            </div>
            <footer className="footerDetails">
              <h4 className="title">{recordedSession?.title}</h4>
              {recordedSession?.presenters?.length ? (
                <>
                  <h6 className="presenter">
                    Presenter: {recordedSession?.presenters?.[0]?.name}
                  </h6>
                  <div
                    className="presenterDesc"
                    dangerouslySetInnerHTML={{
                      __html:
                        recordedSession?.presenters?.[0]?.descriptionHtml || '',
                    }}
                  />
                </>
              ) : null}
            </footer>
          </div>
          <aside className="rightGrid">
            {recordedSession?.m1Upload && (
              <OnDemandFile
                title={recordedSession?.m1Title}
                desc={recordedSession?.m1Desc}
                url={recordedSession?.m1Upload}
              />
            )}
            {recordedSession?.m2Upload && (
              <OnDemandFile
                title={recordedSession?.m2Title}
                desc={recordedSession?.m2Desc}
                url={recordedSession?.m2Upload}
              />
            )}
            {recordedSession?.m3Upload && (
              <OnDemandFile
                title={recordedSession?.m3Title}
                desc={recordedSession?.m3Desc}
                url={recordedSession?.m3Upload}
              />
            )}
            <Note sessionId={recordedSession.id} />
          </aside>
        </div>
      </div>
    </OnDemandShowStyle>
  )
}

export default OnDemandShow
